// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container--IWqN6","form":"styles-module__form--rS61Y"};